import { IEvent } from "@quest/adapter-interface";
import { SpineBase } from "@quest/base-core";
import { BaseViewBehavior } from "@quest/murka-games-behavior-panther";
 
export class StickyFramesView extends BaseViewBehavior {
    constructor(viewJson: any) {
        super(viewJson);
    }
    protected resize(evt: IEvent): void {
        //do noting will resize as per freegame view
    }

    public createSpineClone(stoneAnimId: any): SpineBase {
        const spine: any = this.createSpine(stoneAnimId);
        return spine;
    }

}